angular
    .module('rating.due.components', ['app.services'])
    .component('ratingDue', {
        templateUrl: 'ng/components/rating/rating.due.view.html',
        controllerAs: 'RatingDueCtrl',
        bindings: {
            variabile: '=',
            dataOk: '&'
        },
        controller: function () {
            var self = this;


            self.$onInit = function () {
                console.log('rating due self', self);
            };

            self.change = function () {
                if (self.nota) {

                    //&&
                    // self.telefonoCliente &&
                    // self.personaCliente &&
                    // self.telefonoBanca &&
                    // self.personaBanca &&
                    // self.emailBanca &&
                    // self.emailCliente) {
                    self.variabile = true;
                    self.dataOk({
                        param: 'evvai!'
                    });

                }
            }

        }


    });